<template>
  <div class="customer-detail">
    <div class="breadcrumb">
      <i class="el-icon-arrow-left"></i>
      <el-breadcrumb separator-class="el-icon-arrow-left">
        <el-breadcrumb-item>客户管理</el-breadcrumb-item>
        <el-breadcrumb-item>客户详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="back">
        <div class="customer-tab">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane
              label="客户基础信息"
              name="customerFirst"
            ></el-tab-pane>
            <el-tab-pane
              v-if="isOldCustomer && type"
              label="服务使用信息"
              name="customerSecond"
            ></el-tab-pane>
            <el-tab-pane
              v-if="getUserIdentity != 3 && type"
              label="客户财务信息"
              name="customerThird"
            ></el-tab-pane>
          </el-tabs>
        </div>
        <span class="go-back" @click="goBack">返回</span>
      </div>
      <!-- 客户基础信息 -->
      <div v-if="activeName == 'customerFirst'">
        <BaseInfo :showAgent="false"  :userType="userType" :agentCustomer="true"></BaseInfo>
      </div>
    </div>

    <!-- 服务使用信息 -->
    <div v-if="isOldCustomer && activeName == 'customerSecond'">
      <ServiceInfo :activeName="activeName"></ServiceInfo>
    </div>

    <!-- 客户财务信息 -->
    <div v-if="isOldCustomer && activeName == 'customerThird'">
      <FinancialInfo></FinancialInfo>
    </div>
</div>
</template>

<script>
import Api from '@/api'
import { statusCode } from '@/config'
import { setStorageItem, getStorageItem, removeStorageItem } from '@/utils'

import FinancialInfo from '../customerManagement/component/financialInfo'
import ServiceInfo from '../customerManagement/component/serviceInfo.vue'
import BaseInfo from '../customerManagement/component/BaseInfo.vue'

export default {
  name: 'CustomerDetail',
  components: {
    FinancialInfo,
    ServiceInfo,
    BaseInfo,
  },
  data() {
    return {
      userType:'', // 用户身份类型 1法人 2自然人
      type:null,
      activeName: 'customerFirst', // customerFirst customerSecond
    }
  },
  beforeRouteLeave(to, from, next) {
    // 设置下一个路由的 meta packageDetails 服务使用清空的时候清除记录
    if (['packageDetails', 'billingDetails'].includes(to.name)) {
    } else {
      sessionStorage.removeItem('serviceQuery')
    }
    if (to.name != 'orderDetail'){
      sessionStorage.removeItem('financialQuery')
    }
     next()
  },
  computed: {
    getUserIdentity() {
      return getStorageItem('loginInfo').roleID
    },
    getCustomertab() {
      return this.$store.state.customertab
    },
    // 腾讯内部和官网显示服务信息和财务信息
    isOldCustomer(){
      return true
    }
  },
  created() {
    if (this.$store.state.customertab) {
      this.activeName = this.$store.state.customertab
    }
    window.onbeforeunload = e => { // 刷新时 将列表的中的查询数据就行清空
       sessionStorage.getItem('serviceQuery') && sessionStorage.removeItem('serviceQuery')
       sessionStorage.getItem('financialQuery') && sessionStorage.removeItem('financialQuery')
    };
  },
  mounted() {
    //自然人值展示基本信息模块
    this.type = this.$route.query.type=="1"?true:false

    this.userType = this.$route.query.userType || ''
  },
  methods: {
    // 详情切换
    handleClick() {
      this.$store.commit('setCustomerTab', this.activeName)
      if(this.activeName != 'customerSecond'){
          sessionStorage.removeItem('serviceQuery')
      } 

     if(this.activeName !=  'customerThird'){
        sessionStorage.removeItem('financialQuery')
      }
    },
    goBack() {
      // agentcustomerinfo=agentcustomerinfo
      if(this.$route.query.agentcustomerinfo && this.$route.query.agentcustomerinfo == 'agentcustomerinfo'){ // 如果代理商 代理商客户列表 详情进来的详情，则返回到列表页面
        this.$router.push('/agent/agentManagementList')
      }else{
         this.$router.go(-1)
      }
     
    //   this.$store.commit('setCustomerTab', '')
    },
  },
}
</script>

<style lang="scss" scoped>
.customer-detail {
  width: 100%;
  background-color: #fff;
  .line {
    width: 100%;
    height: 10px;
    background-color: #f7f7f7;
  }
  .breadcrumb {
    display: flex;
    height: 50px;
    background-color: #ffffff;
    line-height: 50px;
    padding-left: 15px;
    i {
      line-height: 50px;
      margin-left: 15px;
    }
    .el-breadcrumb {
      line-height: 50px;
    }
  }
  .content {
    background-color: #ffffff;
    .back {
      height: 60px;
      margin-top: 10px;
      background-color: #ffffff;
      // border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      position: relative;
      span.go-back {
        position: absolute;
        right: 25px;
        color: #2455ce;
        font-size: 16px;
        cursor: pointer;
        top: 20px;
      }
    }
  }
  .customer-tab {
    position: relative;
    flex: 1;
    width: 100%;
    ::v-deep .el-tabs__nav-wrap {
      padding-left: 35px;
      height: 60px;
      line-height: 60px;
      .el-tabs__item {
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        color: #999;
      }
      .el-tabs__item.is-active {
        color: #2455ce;
      }
      .el-tabs__active-bar {
        height: 4px;
        background-color: #2455ce;
      }
    }
  }
}
</style>
